import React from 'react';
import { Lightbulb } from 'lucide-react';
import '../css/empty-state.css';

/**
 * Reusable empty state component for sections with no data
 * @param {string} title - Main title text (default: "Empty state")
 * @param {string} subtitle - Subtitle/description text
 * @param {React.Component} icon - Custom icon component (default: Lightbulb)
 * @param {React.ReactNode} children - Optional CTA button or additional content
 * @param {string} className - Additional CSS classes
 */
const EmptyStateCard = ({
    title = "Empty state",
    subtitle = "There's nothing here yet.",
    icon: Icon = Lightbulb,
    children,
    className = ""
}) => {
    return (
        <div className={`empty-state-card ${className}`}>
            <div className="empty-state-content">
                <div className="empty-state-icon">
                    <Icon size={48} strokeWidth={1.5} />
                </div>
                <h3 className="empty-state-title">{title}</h3>
                {subtitle && <p className="empty-state-subtitle">{subtitle}</p>}
                {children && <div className="empty-state-actions">{children}</div>}
            </div>
        </div>
    );
};

export default EmptyStateCard;
